/*!
 * lazy-images.js - minimal lazy-image hydrator
 *
 * Replaces assets/wnw-optimization.js (from a long-uninstalled Shopify app
 * - Charles confirmed 2026-04-30). Only does what the rest of the theme
 * still depends on: hydrate `img.lazy2` and `img.lazy3` placeholders that
 * snippets/rimg-3.liquid emits, used by home-blog-posts, home-event-posts
 * and testimonial sections (per audit at .lighthouse/ai-audit/AUDIT-lazyload2-usage.md).
 *
 * Uses native IntersectionObserver with a 200px root margin so images
 * hydrate just before they enter the viewport. Falls back to immediate
 * hydration on browsers that don't support IO (none of our supported
 * browsers, but defensive).
 *
 * Note: this script is also referenced by `<script type="lazyload2">`
 * tags in older theme code - those are NOT hydrated here. They were
 * migrated to native loading patterns in the same commit that introduced
 * this file. If you find a `<script type="lazyload2">` tag in any new
 * code, use a normal `<script defer>` or interaction-defer pattern
 * instead - don't re-introduce the chain.
 */
(function () {
  function hydrate(img) {
    if (img.dataset.src) img.src = img.dataset.src;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.classList.remove('lazy2', 'lazy3');
  }

  function findAll() {
    return document.querySelectorAll('img.lazy2, img.lazy3');
  }

  if (!('IntersectionObserver' in window)) {
    // Old browser fallback - hydrate everything immediately
    var run = function () { findAll().forEach(hydrate); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        hydrate(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });

  function observeAll() {
    findAll().forEach(function (img) { io.observe(img); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
})();
